import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'src/AppContext';
import Button from 'src/components/Button';
import useCustomHistory from 'src/hooks/useCustomHistory';

export default function PasswordExpire(): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useCustomHistory();

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.push('/login');
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  return (
    <>
      <div className="container mb-32 mt-6">
        <h1 className="N_20_R">oops!</h1>
        <div className="mt-7 N_14_R text-brown-grey">{t('password/expire/subtitle_1')}</div>
        <div className="mt-4 N_14_R text-brown-grey">{t('password/expire/subtitle_2')}</div>
        <div className="mt-10 grid grid-cols-2 gap-x-3">
          <Button title={t('account/complete/login_button')} theme="sub" onClick={() => history.push('/login')}></Button>
          <Button title={t('password/expire/password_reset_button')} onClick={() => history.push('/password/reset')}></Button>
        </div>
      </div>
    </>
  );
}
